import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-16118492"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-filter" }
const _hoisted_2 = { class: "form-block" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-block-title bold" }, "Данные для авторизации", -1))
const _hoisted_4 = { class: "flex some-inputs m-t-8" }
const _hoisted_5 = { class: "flex flex-col m-r-20 input-container" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Почта для входа в систему", -1))
const _hoisted_7 = { class: "flex flex-col input-container" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Пароль", -1))
const _hoisted_9 = {
  key: 1,
  class: "flex"
}
const _hoisted_10 = { class: "form-block" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-block-title bold" }, "Основные данные", -1))
const _hoisted_12 = { class: "flex some-inputs m-t-8" }
const _hoisted_13 = { class: "flex flex-col m-r-20 input-container" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Фамилия", -1))
const _hoisted_15 = { class: "flex flex-col input-container" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Имя", -1))
const _hoisted_17 = { class: "flex some-inputs m-t-8" }
const _hoisted_18 = { class: "flex flex-col m-r-20 input-container" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Организация", -1))
const _hoisted_20 = { class: "flex flex-col input-container" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Департамент", -1))
const _hoisted_22 = { class: "flex m-t-8" }
const _hoisted_23 = { class: "flex flex-col fl-1" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Роль", -1))
const _hoisted_25 = { class: "flex fl-1 m-t-20 fl-jc-sb" }

import { ref, watch, onMounted } from "vue";

import { useAuthStore } from "@/store/auth/login";
import { useUsersStore } from "@/store/users/users";
import { useRouter } from "vue-router";

import InputText from "primevue/inputtext";
import Button from "primevue/button";
import Skeleton from "primevue/skeleton";


export default /*#__PURE__*/_defineComponent({
  __name: 'UsersViewForm',
  setup(__props) {

const user = ref({
  fname: "",
  lname: "",
  organization: "",
  department: "",
  role: "",
  email: "",
  password: "*********",
});

const nameCopy = ref({
  fname: "",
  lname: "",
});

const isLoading = ref(false);

const saveVisible = ref(false);

const authStore = useAuthStore();
const usersStore = useUsersStore();
const router = useRouter();

const setVisible = () => {
  if (
    (user.value.fname != nameCopy.value.fname ||
      user.value.lname != nameCopy.value.lname) &&
    user.value.fname != "" &&
    user.value.lname != ""
  )
    saveVisible.value = true;
  else saveVisible.value = false;
};

watch(
  () => user.value.fname,
  () => {
    setVisible();
  },
  { immediate: true }
);

watch(
  () => user.value.lname,
  () => {
    setVisible();
  },
  { immediate: true }
);

const reload = () => {
  isLoading.value = true;
  usersStore
    .getCurrentUser()
    .then((userClone) => {
      user.value.fname = userClone.fname;
      user.value.email = userClone.email;
      user.value.lname = userClone.lname;

      nameCopy.value.fname = userClone.fname;
      nameCopy.value.lname = userClone.lname;

      if (userClone.role) {
        user.value.role = userClone.role.name;
        user.value.department = userClone.role.department.name;
        user.value.organization = userClone.role.department.organization.name;
      }
    })
    .finally(() => {
      isLoading.value = false;
    });
};

onMounted(() => {
  reload();
});

function logout() {
  authStore.logout().then(() => {
    location.reload();
  });
}

const changeFI = () => {
  usersStore
    .editCurrentUser({ lname: user.value.lname, fname: user.value.fname })
    .then(() => {
      nameCopy.value.fname = user.value.fname;
      nameCopy.value.lname = user.value.lname;
      saveVisible.value = false;
    });
};

const cancel = () => {
  user.value.fname = nameCopy.value.fname;
  user.value.lname = nameCopy.value.lname;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          (isLoading.value)
            ? (_openBlock(), _createBlock(_unref(Skeleton), {
                key: 0,
                height: "2rem",
                class: "mb-2"
              }))
            : _createCommentVNode("", true),
          (!isLoading.value)
            ? (_openBlock(), _createBlock(_unref(InputText), {
                key: 1,
                placeholder: "Введите значение",
                modelValue: user.value.email,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((user.value.email) = $event)),
                disabled: true
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          (isLoading.value)
            ? (_openBlock(), _createBlock(_unref(Skeleton), {
                key: 0,
                height: "2rem",
                class: "mb-2"
              }))
            : _createCommentVNode("", true),
          (!isLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(_unref(InputText), {
                  class: "m-r-8 fl-1",
                  placeholder: "Введите значение",
                  modelValue: user.value.password,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((user.value.password) = $event)),
                  disabled: true
                }, null, 8, ["modelValue"]),
                _createVNode(_unref(Button), {
                  icon: "pi pi-pencil",
                  class: "purple-button",
                  "aria-label": "Изменить пароль",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push({ name: 'changePassword' })))
                })
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _hoisted_11,
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          (isLoading.value)
            ? (_openBlock(), _createBlock(_unref(Skeleton), {
                key: 0,
                height: "2rem",
                class: "mb-2"
              }))
            : (_openBlock(), _createBlock(_unref(InputText), {
                key: 1,
                placeholder: "Введите значение",
                modelValue: user.value.lname,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((user.value.lname) = $event))
              }, null, 8, ["modelValue"]))
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          (isLoading.value)
            ? (_openBlock(), _createBlock(_unref(Skeleton), {
                key: 0,
                height: "2rem",
                class: "mb-2"
              }))
            : (_openBlock(), _createBlock(_unref(InputText), {
                key: 1,
                placeholder: "Введите значение",
                modelValue: user.value.fname,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((user.value.fname) = $event))
              }, null, 8, ["modelValue"]))
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          (isLoading.value)
            ? (_openBlock(), _createBlock(_unref(Skeleton), {
                key: 0,
                height: "2rem",
                class: "mb-2"
              }))
            : (_openBlock(), _createBlock(_unref(InputText), {
                key: 1,
                placeholder: "Введите значение",
                modelValue: user.value.organization,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((user.value.organization) = $event)),
                disabled: true
              }, null, 8, ["modelValue"]))
        ]),
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          (isLoading.value)
            ? (_openBlock(), _createBlock(_unref(Skeleton), {
                key: 0,
                height: "2rem",
                class: "mb-2"
              }))
            : (_openBlock(), _createBlock(_unref(InputText), {
                key: 1,
                placeholder: "Введите значение",
                modelValue: user.value.department,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((user.value.department) = $event)),
                disabled: true
              }, null, 8, ["modelValue"]))
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _hoisted_24,
          (isLoading.value)
            ? (_openBlock(), _createBlock(_unref(Skeleton), {
                key: 0,
                height: "2rem",
                class: "mb-2"
              }))
            : (_openBlock(), _createBlock(_unref(InputText), {
                key: 1,
                placeholder: "Введите значение",
                modelValue: user.value.role,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((user.value.role) = $event)),
                disabled: true
              }, null, 8, ["modelValue"]))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("div", {
        class: _normalizeClass(["flex", [!saveVisible.value ? 'none' : '']])
      }, [
        _createVNode(_unref(Button), {
          label: "Сохранить",
          onClick: changeFI,
          class: "m-r-20 f-12"
        }),
        _createVNode(_unref(Button), {
          label: "Сбросить изменения",
          onClick: cancel,
          class: "black-12",
          severity: "secondary"
        })
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["flex fl-jc-end", [!saveVisible.value ? 'fl-1' : '']])
      }, [
        _createVNode(_unref(Button), {
          label: "Выйти из аккаунта",
          class: "purple-button",
          icon: "pi pi-sign-out",
          onClick: logout
        })
      ], 2)
    ])
  ]))
}
}

})